const custodianDetailCopy = {
  addressLabel: 'Address:',
  descriptionLabel: 'Description:',
  swiftLabel: 'SWIFT:',
  updateLabel: 'Update',
};

export default custodianDetailCopy;
